import { identity, isEmpty } from 'lodash';

export class LockFirstAndQueue {
    private _isLocked: boolean;
    private readonly _queue: any[];

    constructor() {
        this._isLocked = false;
        this._queue = [];
    }

    async dispatch(fn, errorTransform) {
        if (!this._isLocked) {
            const flush =
                isError =>
                (value, transform = x => x) => {
                    setImmediate(() => {
                        while (!isEmpty(this._queue)) {
                            const { resolve, reject } = this._queue.shift();
                            if (isError) {
                                reject(transform(value));
                            } else {
                                resolve(transform(value));
                            }
                        }
                        this._isLocked = false;
                    });
                };

            this._isLocked = true;

            return await Promise.resolve(fn())
                .then(async value => {
                    if (value.error) {
                        flush(true)(value, errorTransform);
                        return await Promise.reject(value);
                    }

                    flush(false)({}, identity);
                    return value;
                })
                .catch(async error => {
                    flush(true)(error, errorTransform);
                    return await Promise.reject(error);
                });
        }

        return await new Promise((resolve, reject) => {
            this._queue.push({ resolve, reject });
        });
    }
}
